import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const SpeiOutContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;
